import React from 'react';
import PublicLegalContentPage from '../../components/public/PublicLegalContentPage';

const AboutPage = () => (
  <PublicLegalContentPage
    slug="about"
    seoTitle="About | Pleerity Enterprise"
    seoDescription="Built for organisations that need structure, not guesswork. Structured compliance technology and audit visibility for UK landlords and property professionals."
    canonicalUrl="/about"
  />
);

export default AboutPage;
